'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _ChatAreaAlertContainer = require('../components/ChatAreaAlertContainer');

var _ChatAreaAlertContainer2 = _interopRequireDefault(_ChatAreaAlertContainer);

var _attachmentsErrorForThreadInProps = require('../../file-uploads/selectors/attachmentsErrorForThreadInProps');

var _dismissAttachmentsError = require('../../file-uploads/actions/dismissAttachmentsError');

var _selectAttachmentFile = require('../../file-uploads/actions/selectAttachmentFile');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, _ref) {
  var thread = _ref.thread;
  return {
    attachmentsError: (0, _attachmentsErrorForThreadInProps.attachmentsErrorForThreadInProps)(state, { thread: thread })
  };
};

var mapDispatchToProps = {
  dismissAttachmentsError: _dismissAttachmentsError.dismissAttachmentsError,
  selectAttachmentFile: _selectAttachmentFile.selectAttachmentFile,
  trackInteraction: _trackInteraction.trackInteraction
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ChatAreaAlertContainer2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/threads/containers/ConnectedChatAreaAlertContainer.js
// module id = 1170
// module chunks = 2 3